import { render, staticRenderFns } from "./InfiniteFooter.vue?vue&type=template&id=7946843c"
import script from "./InfiniteFooter.vue?vue&type=script&lang=js"
export * from "./InfiniteFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports